module.exports = {
    AUTH: 'https://login-stg.paytmmoney.com',
    PASSCODE_URL: 'https://web-staging-passcode.paytmmoney.com/stocks/passcode',
    DATA: 'https://api-eq-stg.paytmmoney.com',
    ORDERS: 'https://api-eq-order-stg.paytmmoney.com',
    DATA_BROADCAST: 'wss://broadcast-stg.paytmmoney.com',
    MDE_BROADCAST: 'wss://mde-stg.paytmmoney.com/broadcast-service/ws/feed',
    MDE_GATEWAY: 'https://mde-stg.paytmmoney.com',
    ORDER_BROADCAST: 'wss://broadcast-order-stg.paytmmoney.com/bcorder?version=2',
    PROFILE: 'https://api-staging.paytmmoney.com',
    PLATFORM: 'https://pf-stg.paytmmoney.com',
    WEB_APP: 'https://web-staging.paytmmoney.com',
    STOREFRONT: 'https://api-staging.paytmmoney.com/aggr/sf/stage-pml-web-equity-dashboard',
    PROMO_ID: 331032,
    EQUITY_DOWNTIME: 'https://static.paytmmoney.com/data/v1/stage/frontend-config.json',
    MDE_CONFIG: 'https://static.paytmmoney.com/data/v1/staging/mde-config.json',
    BASE: 'https://api-staging.paytmmoney.com',
    ALLOWED_USER_JSON: 'https://static.paytmmoney.com/data/v1/staging/tvcohort.json',
    ORDER_RESTRICTION_CONFIG: 'https://static.paytmmoney.com/data/v1/staging/orderrestrictions.json',
    EQ_MISC_CONFIG: 'https://static.paytmmoney.com/data/v1/eq-web-misc-config.json',
    FNO_SEARCH: 'https://static.paytmmoney.com/data/v1/staging/fno-dashboard-search-scrips.json',
    EQUITY_INFOCARD: 'https://static.paytmmoney.com/data/v1/staging/equity-infocard.json',
    LOGGER: 'https://api-eq-stg.paytmmoney.com',
};
